export default __webpack_public_path__ + "static/media/body-section-glutes.7d6323a0.png";